import { type MCPServerInfo } from '../../types';

const AsanaServer: MCPServerInfo = {
  serverId: 'ASANA',
  name: 'Asana',
  slug: 'asana',
  description: 'Asana MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.asana.com/v2/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default AsanaServer;
